module.exports = __webpack_public_path__ + "img/showcase-ios.c0a7d8cd.png";